namespace Core {
    class MultiSectorFlight {

        constructor(
            private broker
        ) {
        }

        isSameCarrierOnAllSegments(flightSector) {
            return flightSector.Segments.every(s => s.CodeshareAirlineName === s.CarrierName);
        }

        showModalFlightDetails(flightSector) {
            this.broker.publish('showModalFlightDetails', { flight: { Legs : [flightSector] } });
        }
    }

    angular
        .module('core')
        .directive('multiSectorFlight', (): ng.IDirective => {
            return {
                replace: true,
                restrict: 'E',
                scope: {
                    legs: '='
                },
                templateUrl: 'partials/home/directivetemplate?type=multisectorflight',
                controller: MultiSectorFlight,
                controllerAs: 'msf'
            };
        });
}
